<template>
  <a-dropdown
    :open="dropdownOpen"
    v-bind="dropDownProps"
    :disabled="disabled"
    :class="bem.b()"
    @open-change="handleDropdownOpenChange"
  >
    <ll-button v-bind="computedButtonProps" :disabled="disabled">
      <div :class="bem.m('icon-box')">
        <slot name="icon">
          <ll-icon v-bind="iconProps" />
        </slot>
        <span>{{ buttonProps?.label ?? '新增' }}</span>
        <ll-icon
          v-if="showExpandType"
          :class="bem.m('icon-right')"
          :icon-name="
            !dropdownOpen ? 'icon-line-arrow-down' : 'icon-line-arrow-folding'
          "
        />
      </div>
    </ll-button>
    <template #overlay>
      <a-menu @click="handleDropdownClick">
        <a-menu-item
          v-for="(item, index) in dropdownItems"
          :key="item?.key ?? index"
          :disabled="item.disabled || props.disabled"
          @click.stop="handleMenuItemClick(item)"
        >
          <slot name="menuItem" v-bind="item">
            <div :class="bem.m('icon-box')">
              <ll-icon v-if="item.iconProps" v-bind="item.iconProps" />
              <span>{{ item ? item.label : '-' }}</span>
            </div>
          </slot>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script setup lang="ts">
// Import
import { ref, computed } from 'vue'
import { createNamespace } from '@ll-plus/utils'
import {
  dropdownButtonSimpleProps,
  defaultButtonProps,
  dropdownButtonSimpleEmits,
  type DropdownItemProps
} from './dropdown-button-simple'
// Default
defineOptions({ name: 'LlDropdownButtonSimple' })
const bem = createNamespace('dropdown-button-simple')
const props = defineProps(dropdownButtonSimpleProps)
const emits = defineEmits(dropdownButtonSimpleEmits)

// Data
const dropdownOpen = ref<boolean>(false)

const computedButtonProps = computed(() => ({
  ...defaultButtonProps,
  ...props.buttonProps
}))
// Methods
const handleMenuItemClick = (item: DropdownItemProps): void => {
  emits('clickItem', item)
}
const handleDropdownOpenChange = (open: boolean) => {
  dropdownOpen.value = open
}
const handleDropdownClick = () => {
  dropdownOpen.value = false
}
</script>
